import { render } from "./CreateReturn.vue?vue&type=template&id=43f5db52"
import script from "./CreateReturn.vue?vue&type=script&lang=js"
export * from "./CreateReturn.vue?vue&type=script&lang=js"

import "./CreateReturn.vue?vue&type=style&index=0&id=43f5db52&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__